import React from "react";
import { Button } from "antd";
import { optionLabel } from "../../../utils/Helpers";

const ModalBtn = ({type = ('a' || 'btn'), value = null, title = null, icon = null, formBody = null, onAction = ()=>{} }) => {

  const onActionBtn = () => {
    onAction(value, title, formBody)
  }
  return (
    type === 'btn' ? 
      <Button onClick={()=>onActionBtn()}>{icon || ""} {optionLabel(title) || ""}</Button>
      :
      <a onClick={()=>onActionBtn()}>{icon || ""}{icon ?" ": ""}{optionLabel(title) || ""}</a>
  );
};
export default ModalBtn;
